module.exports = __webpack_public_path__ + "img/sms.4f812d35.svg";